<template> </template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import Axios from "axios";

export default {
  data() {
    return {};
  },
  mounted() {
    const json = JSON.parse(window.name);

    localStorage.setItem("accessToken", json.accessToken);
    localStorage.setItem("refreshToken", json.refreshToken);
    localStorage.setItem("adminFirstName", json.adminFirstName);
    localStorage.setItem("adminLastName", json.adminLastName);
    localStorage.setItem("adminRole", json.adminRole);
    localStorage.setItem("adminRolePermission", json.adminRolePermission);
    localStorage.setItem("adminRoleId", json.adminRoleId);
    localStorage.setItem("adminId", json.adminId);
    localStorage.setItem("adminProjects", json.adminProjects);

    Axios.post(
      `${process.env.HOST}/api/admin/auth/retoken`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refreshToken")}`
        }
      }
    )
      .then(response => {
        if (response.status === 200) {
          localStorage.setItem(
            "accessToken",
            response.data.accessToken.accessToken
          );
          baanRueJaiClient.setAuthorizationToken(
            response.data.accessToken.accessToken
          );

          this.$router.push({
            name: json.route,
            params: json.params
          });
        } else {
          this.$router.push({
            name: "Login"
          });
        }
      })
      .catch(e => {
        this.$router.push({
          name: "Login"
        });

        throw e;
      });
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/general/Redirect.vue